export const RETURN_QUERY_KEY = 'return';

/**
 * Read a return value into a same-origin relative path, or null when it points elsewhere.
 */
export function safeReturnPath(value) {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== 'string' || !raw.startsWith('/')) {
    return null;
  }

  const url = sameOriginUrl(raw);

  return url ? relativeHref(url) : null;
}

/**
 * Tag a link with the page its modal should close back to.
 */
export function withReturnPath(href, returnPath) {
  if (href === '' || !returnPath) {
    return href;
  }

  const url = sameOriginUrl(href);
  if (!url) {
    return href;
  }

  url.searchParams.set(RETURN_QUERY_KEY, returnPath);

  return relativeHref(url);
}

/**
 * Drop the return key from a route query, preserving the object when it is absent.
 */
export function queryWithoutReturnPath(query) {
  if (!(RETURN_QUERY_KEY in query)) {
    return query;
  }

  const rest = { ...query };
  delete rest[RETURN_QUERY_KEY];

  return rest;
}

/**
 * Resolve a value to a same-origin URL, or null when it points elsewhere.
 */
export function sameOriginUrl(value) {
  try {
    // A leading-slash test is not enough: browsers read `//evil.com` and `/\evil.com` as
    // authorities, so both escape the origin. Resolving against our own origin and
    // requiring a match is the only check that holds for every such form.
    const url = new URL(value, window.location.origin);

    return url.origin === window.location.origin ? url : null;
  } catch {
    return null;
  }
}

function relativeHref(url) {
  return `${url.pathname}${url.search}${url.hash}`;
}
